import { RECEIVE_REORDER_STANDINGS } from '../util/actionTypes';

export const receiveReorderStandings = (tourName, standings) => ({
  type: RECEIVE_REORDER_STANDINGS,
  payload: standings,
  tourName,
});
